import React, { useEffect, useRef } from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
import { markerIcon } from './marker-icon';
import sphereKnn from 'sphere-knn';
import { useDetailsContext } from '../details';

export const RouteMarker = ({ route, activityId, handleAddWaypoint }) => {
  const [state, dispatch] = useDetailsContext();
  const positionMarkerRef = useRef();
  const routeLookupRef = useRef();

  useEffect(() => {
    // Update the reference to the route when it changes
    routeLookupRef.current = sphereKnn(route);
  }, [route]);

  useEffect(() => {
    if (state.indicator) {
      positionMarkerRef.current.setLatLng([
        state.indicator.lat,
        state.indicator.lon,
      ]);
    }
  }, [state.indicator]);

  useMapEvents({
    // removed mousemove event handler to remove conflict with waypoint marker
    // still shows up when mouse is over elevation chart which is the desired behavior
    click(e) {
      const foundPoint = routeLookupRef.current(e.latlng.lat, e.latlng.lng, 1, 100);
      if (foundPoint.length) {
        const { lat, lon } = foundPoint[0];
        const index = route.findIndex((point) => point.lat === lat && point.lon === lon);
        handleAddWaypoint(activityId, index);
      }
    }
  });

  return (
    <Marker
      position={state.indicator ? [state.indicator.lat, state.indicator.lon] : [0, 0]}
      ref={positionMarkerRef}
      interactive={true}
      opacity={state.isIndicatorVisible ? 1 : 0}
      icon={markerIcon}
      zIndexOffset={0}
    />
  );
};

export default RouteMarker;